import { render, staticRenderFns } from "./SettingCustomer.vue?vue&type=template&id=19b804b2&scoped=true"
import script from "./SettingCustomer.vue?vue&type=script&lang=js"
export * from "./SettingCustomer.vue?vue&type=script&lang=js"
import style0 from "./SettingCustomer.vue?vue&type=style&index=0&id=19b804b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b804b2",
  null
  
)

export default component.exports